module.exports = __webpack_public_path__ + "static/media/16UNODC8.bf67ac57.jpg";